import { combineReducers } from 'redux';

// Reducers
import authReducer from './Auth/store/authReducer';

export const reducers = combineReducers({
    login: authReducer
});
